export const FROM_VIEWER = 'fromViewer';
export const VIEWER_MODE_PARAM_ID = 'md';
